// src/main.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { EmpresaProvider } from "./contexts/EmpresaContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { ModuloProvider } from "./contexts/ModuloContext";
import { ToastProvider } from "./contexts/ToastContext";
import ToastHost from "./components/Toast/ToastHost";
import NotificacoesRealtime from "./components/Notificacoes/NotificacoesRealtime";

// CSS global e de temas/layouts
import "./ui/global.css";
import "./ui/variables.css";
import "./ui/desktop.css";
import "./ui/mobile.css";
import "./ui/themes.css";
import "./ui/pro.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <ModuloProvider>
            <EmpresaProvider>
              <ToastProvider>
                {/* Host visual (toasts) */}
                <ToastHost />

                {/* Listeners em tempo real (desktop) */}
                <NotificacoesRealtime />

                <App />
              </ToastProvider>
            </EmpresaProvider>
          </ModuloProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
    
  </React.StrictMode>
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      // Evita "tela branca" por cache antigo após deploy.
      // Remove qualquer Service Worker antigo e limpa caches.
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));

      if (window.caches) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
    } catch (err) {
      console.warn("Falha ao remover service worker/cache", err);
    }
  });
}
